import type React from "react";
import Grid from "antd/lib/grid";

type Options = { desktopWidth?: string | number };

type Result = {
  width: string | number;
  isMobile: boolean;
  bodyMaxHeight: string;
  modalStyle: React.CSSProperties | undefined;
};

export const useResponsiveModalWidth = (options?: Options): Result => {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  if (isMobile) {
    return {
      width: "100%",
      isMobile,
      bodyMaxHeight: "100vh",
      modalStyle: { top: 0, padding: 0, maxWidth: "100vw" },
    };
  }

  return {
    width: options?.desktopWidth ?? "90vw",
    isMobile,
    bodyMaxHeight: "85vh",
    modalStyle: undefined,
  };
};
